import { State } from '../../types';

export const wyoming: State = {
  name: 'Wyoming',
  abbreviation: 'WY',
  terms: [
    {
      word: 'Bairoil',
      phonetic: 'BAIR-oil',
      // audioUrl: '/audio/bairoil.mp3',
      description: 'A town in Sweetwater County, pronounced "BAIR-oil," not "BAY-roil."'
    },
    {
      word: 'Beulah',
      phonetic: 'BYOO-luh',
      // audioUrl: '/audio/beulah.mp3',
      description: 'Town in northeastern Wyoming'
    },
    {
      word: 'Dubois',
      phonetic: 'DOO-boyce or DEW-boyz',
      // audioUrl: '/audio/dubois.mp3',
      description: 'Town in western Wyoming'
    },
    {
      word: 'Gros Ventre',
      phonetic: 'GROW-vaunt',
      // audioUrl: '/audio/dubois.mp3',
      description: 'A river and mountain range in Wyoming; the name translates to “big belly” in French and reflects the region’s French fur trade history.'
    },
    {
      word: 'Kemmerer',
      phonetic: 'KEM-er-er',
      // audioUrl: '/audio/kemmerer.mp3',
      description: 'A city in Lincoln County, pronounced "KEM-er-er," not "KEM-mer."'
    },
    {
      word: 'Meeteetse',
      phonetic: 'meh-TEET-see',
      // audioUrl: '/audio/dubois.mp3',
      description: 'A small town in northwestern Wyoming known for its history, charm, and proximity to outdoor activities like hiking and fishing.'
    },
    {
      word: 'Popo Agie',
      phonetic: 'po-POE-zha',
      // audioUrl: '/audio/popo_agie.mp3',
      description: 'A river and wilderness area, pronounced "po-POE-zha," not "POH-poh AH-gee."'
    },
    {
      word: 'Shoshoni',
      phonetic: 'shuh-SHOW-nee',
      // audioUrl: '/audio/dubois.mp3',
      description: 'A town in central Wyoming named after the Shoshone people, reflecting the area’s Native American heritage.'
    },
    {
      word: 'Teton',
      phonetic: 'TEE-tahn',
      // audioUrl: '/audio/dubois.mp3',
      description: 'A mountain range in northwestern Wyoming, home to Grand Teton National Park and famous for its dramatic peaks and outdoor recreation.'
    },
    {
      word: 'Togwotee',
      phonetic: 'TOE-guh-dee',
      // audioUrl: '/audio/dubois.mp3',
      description: 'A mountain pass in the Absaroka Mountains, offering stunning views and a route to Grand Teton National Park.'
    },
    {
      word: 'Vedauwoo',
      phonetic: 'VEE-duh-VOO',
      // audioUrl: '/audio/dubois.mp3',
      description: 'A popular rock climbing and hiking area with unique granite formations near Laramie, Wyoming.'
    },
    {
      word: 'Wapiti',
      phonetic: 'WAH-puh-tee',
      // audioUrl: '/audio/wapiti.mp3',
      description: 'A community in Park County, pronounced "WAH-puh-tee," not "wah-PEE-tee."'
    },
    {
      word: 'Washakie',
      phonetic: 'WAH-shah-kee',
      // audioUrl: '/audio/dubois.mp3',
      description: 'A county and a historic region named after Chief Washakie, a respected Shoshone leader known for his diplomacy and contributions to the settlement of the region.'
    }
  ]
};